'use client';

import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { FC, useState } from 'react';

import { SetShowDialog } from '../../types';
import { dayjs } from '../../utils';
import { EditorModal } from '../modals/editorModal';

type LeaseInvoiceMonthsModalProps = {
	leaseInvoiceMonths: string[];
	doCreateLeasesFirstMonthInvoices: (x: string[]) => Promise<void>;
	setShowDialog: SetShowDialog;
	theme: any;
};

const LeaseInvoiceMonthsModal: FC<LeaseInvoiceMonthsModalProps> = ({
	leaseInvoiceMonths,
	doCreateLeasesFirstMonthInvoices,
	setShowDialog,
	theme,
}) => {
	const [loading, setLoading] = useState(false);
	const [selectedInvoiceMonths, setSelectedInvoiceMonths] = useState<string[]>(leaseInvoiceMonths);

	return (
		<EditorModal
			headerText='Select the invoices to create:'
			loading={loading}
			saveDisabled={!selectedInvoiceMonths.length}
			handleClose={() => setShowDialog(null)}
			handleSave={async () => {
				setLoading(true);
				await doCreateLeasesFirstMonthInvoices(selectedInvoiceMonths);
			}}
			theme={theme}
		>
			<FormGroup>
				{leaseInvoiceMonths.map((month, i) => (
					<FormControlLabel
						key={i}
						control={
							<Checkbox
								checked={selectedInvoiceMonths.some((m) => m === month)}
								onChange={(_, checked) => {
									setSelectedInvoiceMonths((prev) =>
										checked ? [...prev, month] : prev.filter((m) => m !== month),
									);
								}}
							/>
						}
						label={dayjs.utc(month, 'YYYY-MM').format('MMMM YYYY')}
					/>
				))}
			</FormGroup>
		</EditorModal>
	);
};

export default LeaseInvoiceMonthsModal;
